import PropTypes from 'prop-types';
import './Item.css'
const Item = (props)=>{
    //console.log(props);
    const {title,amount} = props
    const status = amount<0 ?"expense":"income";
    const simbal = amount<0?"- ":"+ ";
    const formatNumber=(num)=> {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    return (
        <li className={status}>{title}<span>{simbal}{formatNumber(Math.abs(amount))}</span></li>
    );
}

Item.propTypes={
    title:PropTypes.string.isRequired,
    amount:PropTypes.number.isRequired
};
Item.defaultProps = {
    title: "ไม่มีข้อมูล"
};
export default Item